module.exports = __webpack_public_path__ + "static/icons/img-info-prestamos-vida.9a537f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prestamos-vida/img-info-prestamos-vida.svg
// module id = sDIB
// module chunks = 1